import { NavLink } from "react-router-dom";
export default function Button({text , click}){
  return (
    <button 
    className={click ? "" 
     :"ml-8" }>
     <NavLink to='/PrivacyPolicy'>{text}</NavLink>
    </button>
  );
} 